import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Twitter } from "lucide-react";

export default function Footer() {
  return (
    <footer
      className="mt-8 mb-2 flex items-center justify-center gap-3 text-xs text-[var(--numex-muted)]"
      data-testid="numex-footer"
    >
      <a
        href="https://www.instagram.com/numexgame/"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="NUMEX on Instagram"
        className="inline-flex hover:text-[var(--numex-ink)] transition-colors"
        data-testid="footer-instagram"
      >
        <Instagram size={16} strokeWidth={1.75} />
      </a>
      <a
        href="https://x.com/numexgame"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="NUMEX on X"
        className="inline-flex hover:text-[var(--numex-ink)] transition-colors"
        data-testid="footer-x"
      >
        <Twitter size={16} strokeWidth={1.75} />
      </a>
      <span className="text-[var(--numex-tile-idle-border)]">|</span>
      <Link to="/privacy" className="hover:text-[var(--numex-ink)] transition-colors" data-testid="footer-privacy">
        Privacy
      </Link>
      <span className="text-[var(--numex-tile-idle-border)]">·</span>
      <Link to="/terms" className="hover:text-[var(--numex-ink)] transition-colors" data-testid="footer-terms">
        Terms
      </Link>
    </footer>
  );
}
